import React from 'react';
import { motion } from 'framer-motion';
import { Bus, GraduationCap, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
export const SikhHeritageForwardCTA = () => {
  return <section className="py-24 md:py-32 bg-black relative overflow-hidden" data-id="element-1895" data-mp="1jl7redwizb9q">
      {/* Background with a warm ivory/gold glow to contrast the dark theme */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-amber-900/20 via-black to-black z-0" data-id="element-1896" data-mp="1noco1ztxciqg"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-6xl" data-id="element-1897" data-mp="1emmzd1rffxwd">
        <div className="bg-gradient-to-br from-[#1a150e] to-black border border-amber-400/30 rounded-2xl p-8 md:p-16 overflow-hidden relative" data-id="element-1898" data-mp="zwyw3uzoqp60">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3" data-id="element-1899" data-mp="14tfiokr8kvgz"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-500/10 rounded-full blur-3xl translate-y-1/3 -translate-x-1/3" data-id="element-1900" data-mp="vvdejwc7hmph"></div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center relative z-10" data-id="element-1901" data-mp="yo443oywypdu">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-1902" data-mp="uo2be5b5p6ap">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-400/10 border border-amber-400/20 mb-6" data-id="element-1903" data-mp="b1e5kxlrxcxz">
                <GraduationCap className="w-4 h-4 text-amber-400" data-id="element-1904" data-mp="prbwvmf02ire" />
                <span className="text-amber-400 text-xs tracking-[0.2em] uppercase font-medium" data-id="element-1905" data-mp="kxqvrli418nz">
                  Student Access Program
                </span>
              </div>

              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-white mb-6 leading-tight" data-id="element-1906" data-mp="3og0x8y7x63c1">
                Sponsor a Bus. <br data-id="element-1907" data-mp="1sbb9poiujw21" />
                <span className="text-amber-400" data-id="element-1908" data-mp="1sa09tzsiv8g7">Pay Heritage Forward.</span>
              </h2>

              <p className="text-white/70 text-lg font-light leading-relaxed mb-8" data-id="element-1909" data-mp="1x9cs078g7rcg">
                Help bring students from public schools, Gurdwara youth groups,
                and diaspora communities to experience their history alive. Your
                sponsorship funds transportation and access during Sikh Heritage
                Month and beyond.
              </p>

              <Link to="/sikh-heritage-forward" className="inline-flex items-center justify-center gap-2 bg-amber-400 hover:bg-amber-500 text-black px-8 py-4 text-sm tracking-[0.15em] uppercase font-medium transition-colors duration-300" data-id="element-1910" data-mp="1ed4phb6tluku">
                Become a Sponsor
                <ArrowRight className="w-4 h-4" data-id="element-1911" data-mp="2tstvy1m15uzk" />
              </Link>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="grid grid-cols-2 gap-4 md:gap-6" data-id="element-1912" data-mp="2yqc0lft0lo1r">
              <div className="bg-gradient-to-br from-amber-400/10 to-amber-400/5 border border-amber-400/40 p-6 md:p-8 rounded-xl backdrop-blur-sm text-center flex flex-col items-center justify-center" data-id="element-1913" data-mp="2q5vsso5lrawb">
                <Bus className="w-10 h-10 text-amber-400 mb-4" data-id="element-1914" data-mp="2g8hf2wb2d07p" />
                <div className="font-serif text-4xl md:text-5xl text-white mb-2" data-id="element-1915" data-mp="2c5ukwoqx737c">
                  50
                </div>
                <div className="text-amber-100/70 text-xs tracking-wider uppercase font-light" data-id="element-1916" data-mp="egcs7z8f8t3u">
                  Students per bus
                </div>
              </div>

              <div className="bg-gradient-to-br from-amber-400/10 to-amber-400/5 border border-amber-400/40 p-6 md:p-8 rounded-xl backdrop-blur-sm text-center flex flex-col items-center justify-center" data-id="element-1917" data-mp="hho6lbq9mhuq">
                <GraduationCap className="w-10 h-10 text-amber-400 mb-4" data-id="element-1918" data-mp="8h9lacdax2r8" />
                <div className="font-serif text-4xl md:text-5xl text-white mb-2" data-id="element-1919" data-mp="8j2m3b18gsrb">
                  12k+
                </div>
                <div className="text-amber-100/70 text-xs tracking-wider uppercase font-light" data-id="element-1920" data-mp="3uwub4en7f6fy">
                  Students in Year 1
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};